import { useEffect, useState } from 'react'
import LogoImg from '../../../assets/symbol_text.png'
import { Step } from 'components/user/v2/Step'
import { StepButton } from 'components/user/v2/StepButton'
import { StepOne } from 'components/user/v2/StepOne'
import { StepTwo } from 'components/user/v2/StepTwo'
import { StepThree } from 'components/user/v2/StepThree'
import { Register } from 'interfaces/user.interface'
import { client, os } from 'utils/lib'
import env from 'config/env'
import { Complete } from 'components/user/v2/Complete'
import { postAuthRegister } from 'api/user.request'
import { useConfirmV2 } from 'contexts/ConfirmV2Provider'
import { Footer } from 'components/user/v2/Footer'

interface SignupLocal extends Register {
    termsAll: string
}

export const SignUpPageV2 = () => {
    const { confirm } = useConfirmV2()
    const [isComplete, setIsComplete] = useState(false)
    const [registerInfo, setRegisterInfo] = useState<SignupLocal>({
        name: '',
        email: '',
        password: '',
        phone: '',
        serviceType: 'SWEB', // 서비스 유형
        client: client(),
        os: os(),
        version: env.VERSION,

        recommender: '',
        snsLinks: '',
        referralPath: '',
        salesCategory: '',
        liveHistory: '',
        businessName: '',
        representativeName: '',
        idCardFileId: -1,
        businessRegistrationFileId: -1,
        businessRegistrationNumber: '',

        termsAll: '',
    })
    const [step, setStep] = useState(0) // 진행 과정 스텝
    const [isNextPossible, setIsNextPossible] = useState(false) // 다음 버튼 활성화 여부

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {}, [])

    const handleRegister = async () => {
        setIsLoading(true)
        const { termsAll, salesCategory, liveHistory, ...rest } = registerInfo
        const data = {
            ...rest,
        } as Register
        if (liveHistory && liveHistory.startsWith(',')) {
            data.liveHistory = liveHistory.substring(1)
        }
        if (salesCategory && salesCategory.startsWith(',')) {
            data.salesCategory = salesCategory.substring(1)
        }

        try {
            await postAuthRegister(data)
            setIsComplete(true)
        } catch (err: any) {
            confirm({
                invisibleCancel: true,
                description: (
                    <>
                        <div>가입 요청에 실패했습니다.</div>
                        <div>지속적으로 발생한다면 고객센터에 문의해 주세요.</div>
                        <div>({err.message})</div>
                    </>
                ),
            })
        } finally {
            setIsLoading(false)
        }
    }
    // 0 ~ 2
    const handlePageChange = async (newStep: number) => {
        if (newStep < 0) return
        if (newStep > 2) {
            // 마지막 요청
            // console.log('가입 요청')
            try {
                handleRegister()
            } catch (err: any) {
                confirm({
                    invisibleCancel: true,
                    description: err.message,
                })
            }
            return
        }

        setStep(newStep)
    }

    // input callback handler
    const handleCallback = (key: keyof Register, value: string) => {
        setRegisterInfo((prev) => ({ ...prev, [key]: value }))
    }

    useEffect(() => {
        // console.log(registerInfo)
        if (step === 0) {
            if (
                registerInfo.businessName &&
                registerInfo.representativeName &&
                registerInfo.businessRegistrationNumber &&
                registerInfo.phone &&
                registerInfo.businessRegistrationFileId &&
                registerInfo.businessRegistrationFileId > 0 &&
                registerInfo.idCardFileId &&
                registerInfo.idCardFileId > 0
            ) {
                setIsNextPossible(true)
            } else {
                setIsNextPossible(false)
            }
        } else if (step === 1) {
            if (registerInfo.name && registerInfo.email && registerInfo.password) {
                setIsNextPossible(true)
            } else {
                setIsNextPossible(false)
            }
        } else if (step === 2) {
            if (registerInfo.termsAll === 'true') {
                setIsNextPossible(true)
            } else {
                setIsNextPossible(false)
            }
        }
    }, [registerInfo, step])

    if (isComplete) {
        return <Complete />
    }

    return (
        <section className="flex h-screen justify-center overflow-y-scroll mt-[30px] pb-[80px]">
            <div className="flex flex-col max-w-[600px] min-w-[320px] w-full items-center gap-8 h-fit px-3">
                <article className="flex flex-col items-center">
                    <img src={LogoImg} className="w-[26%] aspect-auto" alt="" />
                    <h1 className="text-[clamp(22px,6vw,28px)] font-bold text-[#242424]">
                        셀러 가입 신청
                    </h1>
                </article>
                <div className="flex flex-col gap-10 w-full items-center">
                    <Step step={step} />
                    <div className={`w-full flex ${step === 0 ? '' : 'hidden'}`}>
                        <StepOne item={registerInfo as any} callback={handleCallback} />
                    </div>
                    <div className={`w-full flex ${step === 1 ? '' : 'hidden'}`}>
                        <StepTwo item={registerInfo} callback={handleCallback} />
                    </div>
                    <div className={`w-full flex ${step === 2 ? '' : 'hidden'}`}>
                        <StepThree item={registerInfo} callback={handleCallback} />
                    </div>
                </div>
                <div className="flex flex-col gap-5 w-full m-[60px]">
                    <StepButton
                        isLoading={isLoading}
                        step={step}
                        isNextPossible={isNextPossible}
                        onClickNext={() => handlePageChange(step + 1)}
                        onClickPrev={() => handlePageChange(step - 1)}
                    />
                    {step === 0 && <Footer />}
                </div>
            </div>
        </section>
    )
}
